export const API = {
  CHANGE_DATA: `${API_HOST}/customer/info`,
  CHANGE_MSISDN: `${API_HOST}/customer/msisdn/verification`,
};
